<template>
  <div class="zzvideo">
    <bs-detail
      :filter="filter"
      :meta="{ module:'single-article', field:'zzzg' }"
    >
      <template slot="data" slot-scope="slot">
        <div class="mobile-videoplay-img" style="padding-bottom: 20px">
          <video
            style="width:100%"
            src="//file.whlyw.net/zzwh/%E6%9C%B1%E5%AD%90%E4%B9%8B%E6%AD%8C.mp4"
            controls="controls"
            id="video">您的破浏览器都是古董了，早该换了，不然休想看我们的小电影(*′?v?)</video>
          <!-- <img src="../../assets/portal/zwsj.png" style="width: 100%;height: 100%;" /> -->
        </div>
        <div class="mobile-videoplay-content">
          <div class="mobile-videoplay-contenttxt" v-html="slot.data.artContent"></div>
        </div>
      </template>
    </bs-detail>
  </div>
</template>
<script>
require("../../styles/mobile/mobile-arti-detail-video.scss");
export default {
  data() {
    return {
      routeType: "arti",
      filter: {
        artiId: 'f4f2dbe5-a9b0-410c-b72b-f4cfa753d384'
      },
    };
  },
  mounted() {},
  methods: {
    handleGoBack() {
      window.history.back();
    }
  },
  components: {
    BsDetail: () => import("../../components/bs-detail"),
  },
  computed: {
    currentModule() {
      return `${this.$route.params._module}_${this.$route.params._field}`;
    }
  },
  watch: {
    $route: function(to, from) {
      let contain =
        to.name.indexOf(`mobile-${this.routeType}-detail`) !== -1 ||
        from.name.indexOf(`mobile-${this.routeType}-detail`) !== -1;
      if (this.routeWatch && contain && this.$route.params._artiId) {
        this.$refs["refId"].cleaeData();
        this.meta.module = this.$route.params._module;
        this.meta.field = this.$route.params._field;
        this.filter.artiId = this.$route.params._artiId;
        this.$refs["refId"].loadData();
      }
    }
  }
};
</script>
